import { ReactElement, FC, memo } from 'react'

import { BENEFITS, topicIdMap } from '../../../constants'
import { useI18n } from '../../../hooks'
import Image from '../../atoms/images/image'

const Benefits: FC = (): ReactElement => {
  const { t } = useI18n()
  return (
    <div className="about-benefits">
      <h1 className="heavy">{t('About_onTheHubBenefits')}</h1>
      <div className="about-benefits-content">
        {BENEFITS.map((benefit) => {
          return (
            <div className="about-benefit" key={benefit.title}>
              <Image
                className="about-benefit-icon"
                src={benefit.icon}
                alt={`about page ${benefit.title} image`}
                size={{ width: 150, height: 150 }}
              />
              <p className="about-benefit-title heavy">{benefit.title}</p>
              <p className="about-benefit-content">{benefit.content}</p>
              {benefit.title === 'Guaranteed Security' ? (
                <p className="about-benefit-policy">
                  {t('Common_viewOur')}{' '}
                  <a href={`/help?helpCategoryId=${topicIdMap.policies}&helpTopicId=${topicIdMap.privacyPolicy}`} className="heavy">
                    {t('Common_privacyPolicy')}
                  </a>
                  .
                </p>
              ) : null}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default memo(Benefits)
